import { ValidationResult } from '../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../utils/translator.helper';

// see thumbprint from ExtJs
export function thumbprint(value: string): ValidationResult {
  if (!/^([a-f0-9]{64})$/i.test(value) && !/^([a-f0-9]{40})$/i.test(value)) {
    return { valid: false, error: translateFn('Invalid thumbprint') };
  }

  return { valid: true };
}
